export const values = {
    "formType": 'registration',
    "idetifier": {
        "patientData": [
            "name",
            "lastName",
            "middleName",
            "birthDate",
            "gender",
            "cardNumber",
            "patientNumber",
            "phoneNumber"
        ],
        "directionData": [
            "activeDoc",
            "research",
            "biopsy",
            "clinicalConclusion",
            "clinicalInfo",
            "markedMaterial",
            "operationDate",
            "operationName",
            "status",
            "quantityMaterial",
            "departmentId",
            "hospitalId",
        ]
    },
    "title": 'Скерування',
    "dataType": 'registration',
    "fields": [
        {
            "legend": 'Антитіла',
            "id": 1,
            "type": 'text',
            "required": true,
            "name": 'antibodies',
            "dataType": 'antibodies',
            "options": true,
            "props": []
        },
        {
            "legend": 'Реєстраційний номер пацієнта',
            "id": 2,
            "type": 'text',
            "required": true,
            "name": 'patientNumber',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 881,
                    "type": 'text',
                    "placeholder": '№789123'
                },
            ]
        },
        {
            "legend": "Прізвище",
            "id": 3,
            "type": 'text',
            "required": true,
            "name": 'lastName',
            "dataType": 'patientData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 772,
                    "type": 'text',
                    "placeholder": 'Марченко'
                },
            ]
        },
        {
            "legend": "Ім'я",
            "id": 4,
            "type": 'text',
            "required": true,
            "name": 'name',
            "dataType": 'patientData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 771,
                    "type": 'text',
                    "placeholder": 'Сергій'
                },
            ]
        },
        {
            "legend": "По батькові",
            "id": 5,
            "type": 'text',
            "required": true,
            "name": 'middleName',
            "dataType": 'patientData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 773,
                    "type": 'text',
                    "placeholder": 'Віталійович'
                },
            ]
        },
        {
            "legend": 'Стать',
            "id": 6,
            "type": 'select',
            "name": 'gender',
            "dataType": 'patientData',
            "required": true,
            "options": true,
            "props": [
                {
                    "value": 'male',
                    "label": 'чоловік',
                    "id": 661,
                    "type": 'option'
                },
                {
                    "value": 'female',
                    "label": 'жінка',
                    "id": 662,
                    "type": 'option'
                },
            ]
        },
        {
            "legend": 'Вік',
            "id": 7,
            "type": 'text',
            "required": false,
            "name": 'birthDate',
            "dataType": 'patientData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "name": 'ageYears',
                    "id": 5511,
                    "min": 0,
                    "max": 105,
                    "type": 'number',
                    "placeholder": 'Років',
                    "show": false
                },
                {
                    "label": '',
                    "name": 'ageMonths',
                    "id": 5512,
                    "min": 0,
                    "max": 12,
                    "type": 'number',
                    "placeholder": 'Місяців',
                    "show": true
                },
                {
                    "label": '',
                    "name": 'ageDays',
                    "id": 5513,
                    "min": 1,
                    "max": 31,
                    "type": 'number',
                    "placeholder": 'Днів',
                    "show": true
                },
            ]
        },
        {
            "legend": '№ карти стаціонара або амбулаторної карти',
            "id": 8,
            "type": 'text',
            "required": true,
            "name": 'cardNumber',
            "dataType": 'patientData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 221,
                    "type": 'text',
                    "placeholder": '№789123'
                },
            ]
        },
        {
            "legend": 'Біопсія',
            "id": 9,
            "type": 'radio',
            "required": false,
            "name": 'biopsy',
            "dataType": 'directionData',
            "options": false,
            "props": [
                {
                    "label": 'Первинна',
                    "id": 21,
                    "type": 'radio'
                },
                {
                    "label": 'Вторинна',
                    "id": 22,
                    "type": 'radio'
                },
            ]
        },
        {
            "legend": 'Вид операції',
            "id": 10,
            "type": 'text',
            "required": false,
            "name": 'operationName',
            "dataType": 'directionData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 31,
                    "type": 'text',
                    "placeholder": 'Введіть тип операції'
                },
            ]
        },
        {
            "legend": 'Дата операції',
            "id": 11,
            "type": 'date',
            "required": false,
            "name": 'operationDate',
            "dataType": 'directionData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 41,
                    "type": 'date',
                    "min": '',
                },
            ]
        },
        {
            "legend": 'Кількість матеріалу',
            "id": 13,
            "type": 'text',
            "required": true,
            "name": 'quantityMaterial',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 51,
                    "type": 'number',
                    "min": 1,
                    "max": 50,
                },
            ]
        },
        {
            "legend": 'Маркування матеріалу',
            "id": 14,
            "type": 'select',
            "required": true,
            "name": 'markedMaterial',
            "dataType": 'directionData',
            "options": true,
            "props": [
                {
                    "value": 'Біопсія',
                    "label": 'Біопсія',
                    "id": 61,
                    "type": 'option'
                },
                {
                    "value": 'Операційний матеріал',
                    "label": 'Операційний матеріал',
                    "id": 62,
                    "type": 'option'
                },
            ]
        },
        {
            "legend": 'Клінічні дані',
            "id": 15,
            "type": 'text',
            "required": false,
            "name": 'clinicalInfo',
            "dataType": 'directionData',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 71,
                    "type": 'text',
                    "placeholder": 'Bведіть клінічні дані'
                },
            ]
        }, {
            "legend": 'Клінічний діагноз',
            "id": 16,
            "type": 'text',
            "required": false,
            "name": 'clinicalConclusion',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 81,
                    "type": 'text',
                    "placeholder": 'Введіть діагноз'
                },
            ]
        },
        {
            "legend": 'Лікар',
            "id": 17,
            "type": 'text',
            "required": true,
            "name": 'activeDoc',
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 91,
                    "type": 'text',
                    "placeholder": 'Варгалюженко Микола Ігорович'
                },
            ]
        },
        {
            "legend": 'Моб. Телефон Пацієнта',
            "id": 18,
            "type": 'tel',
            "required": true,
            "name": 'phoneNumber',
            "max": 13,
            "options": false,
            "props": [
                {
                    "label": '',
                    "id": 901,
                    "type": 'tel',
                    "max": 13,
                    "defaultValue": '+380',
                    "patter": '[0-9]{3}-[0-9]{3}-[0-9]{4}',
                    "placeholder": '+380967778899'
                },
            ]
        }, {
            "legend": 'Заклад який скеровує',
            "id": 19,
            "type": 'text',
            "required": true,
            "name": 'hospitalId',
            "dataType": 'directionData',
            "options": true,
            "props": []
        }, {
            "legend": 'Договір',
            "id": 20,
            "type": 'text',
            "required": false,
            "name": 'contractId',
            "dataType": 'directionData',
            "options": true,
            "props": []
        },
        {
            "legend": 'Відділення закладу',
            "id": 21,
            "type": 'text',
            "required": true,
            "name": 'departmentId',
            "dataType": 'directionData',
            "options": true,
            "props": []
        },
        {
            "legend": 'Вид дослідження',
            "id": 22,
            "type": 'select',
            "name": 'research',
            "required": true,
            "options": true,
            "isDisabledOpt": true,
            "props": [
                {
                    "value": 'Гістологія',
                    "label": 'Гістологія',
                    "id": 991,
                    "type": 'option'
                },
                {
                    "value": 'ІГХ',
                    "label": 'ІГХ',
                    "id": 992,
                    "type": 'option'
                },
                {
                    "value": 'CISH',
                    "label": 'CISH',
                    "id": 993,
                    "type": 'option'
                },
                {
                    "value": 'Експрес',
                    "label": 'Експрес',
                    "id": 994,
                    "type": 'option'
                },

            ]
        }
    ],
    "button": "Сформувати",
    "class": 'form__box__register'
};